export default "../css/b1fc8c598a577bcb4b2136f9e037d0b6.ttf";